import styled from 'styled-components'
import { colors, media } from 'client/styles'

export const ConditionsBase = styled.section`
  background-color: ${colors.white};
  padding-block: 20px;
  padding-inline: 0;
`

export const Title = styled.h2`
  color: ${colors.grey1};
  font-size: 18px;
  line-height: 1.2;
  font-weight: 700;
  margin-block-end: 20px;

  ${media.tablet} {
    font-size: 28px;
  }
`

export const SubTitle = styled.h3`
  color: ${colors.grey1};
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  margin-block-end: 6px;
`

export const TextStyle = styled.div`
  color: ${colors.grey2};
  font-size: 16px;
  line-height: 24px;
  margin-block-end: 20px;

  p {
    margin-block-start: 6px;
  }

  ul,
  ol {
    list-style: disc;
    margin-inline-start: 30px;
  }

  li {
    font-size: 16px;
    line-height: 24px;
    margin-block-end: 6px;
    padding-inline-start: 5px;
  }
`
